module.exports = __webpack_public_path__ + "static/article-image-03-5ea7be6b6396241c0a90d4ef5d33faec.jpg";